<template>
  <b-row class="align-items-center">
    <b-col lg="auto" class="mb-3 mb-lg-0">
      <c-switch v-model="active" variant="3d" :text="$t('shared.publish')" color="success"/>
    </b-col>

    <b-col>
      <date-picker
        v-if="active"
        :label="label"
        :time="time"
        v-model="model"
      />
    </b-col>
  </b-row>
</template>

<script>
import cSwitch from './Switch'
import DatePicker from './DatePicker'

export default {
  name: 'NullableDateEditor',
  components: {
    cSwitch,
    DatePicker
  },
  props: {
    value: { type: String, default: null },
    time: Boolean,
    label: String
  },
  data () {
    return {
      oldValue: null
    }
  },
  computed: {
    active: {
      get () {
        return this.model ? true : false
      },
      set (val) {
        if (!val) {
          this.oldValue = this.model
        }
        this.model = val ? this.oldValue || new Date().toISOString() : null
      }
    },
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
